import {PollResult} from '../copilot.types';
import {logger} from './logger';

export async function poll({
  checkFn,
  maxAttempts = 20,
  interval = 100,
}: {
  checkFn: () => PollResult;
  maxAttempts?: number;
  interval?: number;
}): Promise<PollResult> {
  return new Promise(async (resolve) => {
    let attempts = 0;
    attempts++;

    logger.log(`Polling attempt ${attempts} of ${maxAttempts}`);

    let checkRes = checkFn();

    if (checkRes.passed) {
      logger.log(`Checks PASSED after ${attempts} attempts`);
      resolve(checkRes);

      return;
    }

    if (attempts >= maxAttempts) {
      logger.log(`Checks have not passed after ${maxAttempts} attempts`);
      resolve(checkRes);

      return;
    }

    const polling = setInterval(async () => {
      attempts++;
      logger.log(`Polling attempt ${attempts} of ${maxAttempts}`);

      checkRes = checkFn();

      if (checkRes.passed) {
        logger.log(`Checks PASSED after ${attempts} attempts`);
        clearInterval(polling);
        resolve(checkRes);

        return;
      } else if (attempts >= maxAttempts) {
        logger.log(`Checks have not passed after ${maxAttempts} attempts`);
        clearInterval(polling);
        resolve(checkRes);

        return;
      }
    }, interval);
  });
}
